<template>
  <div class="max-w-360 m-auto w-full flex justify-center">
    <div class="flex flex-col gap-2 p-4 w-207 rounded-8xl glass-frosted">
      <FirmwareUpdator />

      <DongleUpdator v-if="hasDongleUpdator" />

      <WirelessSleepTime :parameters="parameters" />

      <LowBatteryDisplay :parameters="parameters" />

      <ProductDisplay />

      <FactoryReset />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed, onMounted } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDeviceStore, useFirmwareStore } from '@/stores'
  import { ConnectionType } from '@rapoo/device-sdk'
  import FirmwareUpdator from './components/FirmwareUpdator.vue'
  import DongleUpdator from './components/DongleUpdator.vue'
  import WirelessSleepTime from './components/WirelessSleepTime.vue'
  import LowBatteryDisplay from './components/LowBatteryDisplay.vue'
  import ProductDisplay from '@/components/settings/ProductDisplay.vue'
  import FactoryReset from '@/components/settings/FactoryReset.vue'
  import { useParameters } from '../composables/useParameters.ts'

  const deviceStore = useDeviceStore()
  const { currentDevice } = storeToRefs(deviceStore)
  const hasDongleUpdator = computed(() => {
    // 是无线状态
    const isWireless = currentDevice.value?.getConnectionType() === ConnectionType.Wireless
    if (!isWireless) return false
    // 拥有接收器（这个条件是因为网吧鼠标的接收器是作为一个单独的底座设备存在的）
    const hasDongle =
      Array.isArray(currentDevice.value?.manifest.hardware.productId) &&
      currentDevice.value?.manifest.hardware.productId.length > 1
    if (!hasDongle) return false
    return true
  })

  const firmwareStore = useFirmwareStore()
  firmwareStore.checkLatestVersion()

  const parameters = useParameters()
  onMounted(() => {
    parameters.actions.refresh()
  })
</script>

<style lang="scss" scoped></style>
